import { get, post } from './client';
import type { Me } from '@/types/api';

// Sign-in / sign-up / sign-out / magic link / OAuth are all owned by Clerk.
// FYD's /me + /tos/accept stay because they're business-side.

export const getMe = () => get<Me>('/me');

export const acceptToS = (tos_version: string) =>
  post<{ accepted_at: string; tos_version: string }>('/tos/accept', { tos_version });
